import { removeReplyBlock } from '../../../../../utils/email'
import { toText } from '../../../../../utils/html'
import { removeSignature } from '../../../../../utils/signature'
import { getEmailFormTemplateDependeciesApiParams } from '../../EmailCreationForm.utils'

export function addTemplateValue({
  data,
  templateEntityApiParams,
  templateId,
  user,
}) {
  return {
    ...data,
    dependencies: getEmailFormTemplateDependeciesApiParams({
      templateEntityApiParams,
      user,
    }),
    id: templateId,
  }
}

// "Dirty" means the body has text the user would lose on Replace — i.e. text
// other than the signature and the quoted reply/forward block. The reply block
// (pre-filled when answering) must not count, otherwise the Replace/Insert
// confirmation would always pop up on the first template insert in a reply.
export function isDirtyMessage(value) {
  return toText(removeReplyBlock(removeSignature(value))).trim().length > 0
}
